let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6MiVv")).then(() => parcelRequire('lo4cW'));